@if(showHeader){
<fgb-banner [pageTitle]="title" />
<fgb-page-header [pageTitle]="mobileTitle" [showBalance]="showPoints" [showFooter]="showHeaderFooter"></fgb-page-header>
<div class="mobile-content-wrapper mt-lg-30" *ngIf="!isMobileNavDisabled">
  <div class="container">
    <fgb-route-nav indicatorStyle="rounded" (onTabChange)="title = $event">
      <a
        class="nav-item"
        [routerLink]="['/rewards/marketplace']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <label>{{ 'rewards.nav.marketplace' | translate }}</label>
        <div class="nav-item-bg"></div>
      </a>
      <a
        class="nav-item"
        [routerLink]="['/rewards/raffles']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <label>{{ 'rewards.nav.raffles' | translate }}</label>
        <div class="nav-item-bg"></div>
      </a>
      <a
        class="nav-item"
        [routerLink]="['/rewards/auctions']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <label>{{ 'rewards.nav.auctions' | translate }}</label>
        <div class="nav-item-bg"></div>
      </a>
      <a
        class="nav-item d-lg-flex d-none"
        [routerLink]="['/rewards/wallet']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <label>{{ 'rewards.nav.wallet' | translate }}</label>
        <div class="nav-item-bg"></div>
      </a>
    </fgb-route-nav>
  </div>
</div>
}
<router-outlet></router-outlet>
